<h1 class="title">INTO.CARE MOBILE PLATFORM PRIVACY NOTICE</h1>
<p>
	Accessing into.care and creation of the Account for the purpose of using into.care implies the User’s informed consent
	(through disclosure of the User’s Personal Data or opt-in) to the Privacy Policy and consequently to how Pridiktiv
	collects, uses and processes the Personal Data.
</p>
<p>Why does Pridiktiv collects and further processes the User’s Personal Data?</p>
<ul>
	<li>to provide full functionality of into.care,</li>
	<li>to improve into.care, and</li>
	<li>to draw up statistics regarding the use of into.care;</li>
	<li>to provide an access into.care,</li>
	<li>to let the User use into.care;</li>
</ul>
<p>Pridiktiv may also use the Personal Data for direct marketing purposes.</p>
<p>
	The User is not obliged to provide Pridiktiv with his/her Personal Data, however the User must understand that the
	delivery of certain services is not possible in case the User refuses to provide certain data.
</p>
<p>
	Moreover, according to the new data protection regulation the User has following rights concerning his/her Personal
	Data: the right to be informed, the right to access the data, the right to rectify, erasure or restrict the User’s
	Personal Data, the right to object (for example against direct marketing), the right to withdraw the consent, the
	right to data portability, the right to lodge a complaint with a supervisory authority.
</p>
<p>
	More information about the safety of the Personal Data and the User’s Privacy Rights can be found in the
	<a href="#" (click)="openPrivacyPolicy($event)">Pridiktiv’s Privacy &amp; Cookies Policy</a>
</p>
